import {
  createFrontendModule,
  createTranslationMessages,
} from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { userSettingsTranslationRef } from '@backstage/plugin-user-settings/alpha';

// The Settings page's identity card: "Backstage Identity" is just "Identity" here, and the
// ownership entities (the user plus the team groups they belong to) read as "Member of".
const messages = createTranslationMessages({
  ref: userSettingsTranslationRef,
  messages: {
    'identityCard.title': 'Identity',
    'identityCard.noIdentityTitle': 'No identity',
    'identityCard.ownershipEntities': 'Member of',
  },
});

export const identityModule = createFrontendModule({
  pluginId: 'app',
  extensions: [TranslationBlueprint.make({ params: { resource: messages } })],
});
